import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import React from "react";
import { cn } from "utils";
import { ospThemes } from "@ospweb/sdk-ui";
import type { UpgradeButtonProps } from "./types";
import Translations from "@translate/components/PortfolioContainer/UpgradeButton";
import { I18nUtil } from "@utils/i18n";
import { useMemberFeature } from "@/src/hooks";

const I18n = I18nUtil.createScoped(Translations);

export const UpgradeButton: React.FC<UpgradeButtonProps> = ({
  memberLevel = "free",
  className,
  handleUpgradeClick,
}) => {
  const { isTrial } = useMemberFeature();

  const getButtonText = () => {
    switch (memberLevel) {
      case "free":
        return isTrial ? I18n.t("Start $1 Trial") : I18n.t("Upgrade");
      case "pro":
        return I18n.t("Contact Us");
      case "export":
        return I18n.t("Manage Portfolios");
      default:
        return I18n.t("Upgrade");
    }
  };

  return (
    <button
      aria-label="Upgrade Button"
      data-openreplay-label="Upgrade Button Button"
      id="btn-upgrade-button"
      className={cn(
        "button sm_button max-md:md_button gradient-border-member bg-background_solid_secondary flex-1",
        "inline-flex items-center justify-center gap-1",
        "bg-background_solid_secondary button_m",
        "hover:bg-background_solid_tertiary mx-2",
        className,
      )}
      onClick={handleUpgradeClick}
    >
      <OspIcons
        name="pricing"
        size={20}
        color={ospThemes.colors.content_brand_primary}
      />
      <div className="equity-text-linear">{getButtonText()}</div>
    </button>
  );
};
